export const enum SupportChatEventStatus {
    Found = 0,
    NotFound = 1
}
